export default __webpack_public_path__ + "static/media/gallery-image-6.5085fe79.jpg";